'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.makeSelectors = makeSelectors;

require('arrayq');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeSelectors(name, options, hasSameId) {
    let scope = state => {
        let s = state[name + 'Resource'];
        if (!s) {
            throw new Error('Register reducer of resource ' + name + ' in the store under: "' + name + 'Resource"');
        }
        return s;
    };
    return {
        error: state => scope(state).error,
        itemById: id => state => scope(state).list.qFirst(item => hasSameId(item, (0, _defineProperty3.default)({}, options.id, id))),
        itemByItem: item => state => scope(state).list.qFirst(existing => hasSameId(item, existing)),
        items: state => scope(state).list,
        loading: state => scope(state).loading,
        params: state => scope(state).params
    };
}
//# sourceMappingURL=makeSelectors.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/makeSelectors.js